import React from 'react';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    initial: 'M',
    color: 'bg-pink-100 text-pink-700',
    text: '“Yo no tenía tiempo y me daba miedo que salga mal y tener que tirar los ingredientes. Empesé con una tanda chica, y me sorprendió lo rápido que sale.”'
  }, {
    initial: 'C',
    color: 'bg-blue-100 text-blue-700',
    text: '“Antes probaba recetas sueltas y era frustrante. Acá sentí que por fin tengo un método: sabores, salsas y cómo venderlo sin vergüenza.”'
  }, {
    initial: 'L',
    color: 'bg-green-100 text-green-700',
    text: '“Compré por la garantia. Me llegó al instante al correo. Lo vi, lo entendí y dije: ‘ok, esto sí es para mí’.”'
  }];
  return <section className="py-16 md:py-24 px-4 bg-cream" data-id="element-272">
      <div className="max-w-6xl mx-auto" data-id="element-273">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-brown-dark mb-12" data-id="element-274">
          Escucha lo que dicen quienes ya lo están usando…
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-275">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-276">
              <div className="flex items-center gap-4 mb-6" data-id="element-277">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl ${t.color}`} data-id="element-278">
                  {t.initial}
                </div>
                <div className="flex text-caramel" data-id="element-279">
                  {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-5 h-5 fill-current" data-id="element-280" />)}
                </div>
              </div>
              <p className="text-gray-700 font-medium italic flex-1 text-lg leading-relaxed" data-id="element-281">
                {t.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}